import React from "react";
import { type StyleProp, StyleSheet, View, type ViewStyle } from "react-native";

import { Spacings } from "@/styling/spacings";

type Props = {
  leftComponent: React.ReactNode;
  infoComponent: React.ReactNode;
  rightComponent: React.ReactNode;
  additionalStyle?: StyleProp<ViewStyle> | undefined;
};

// this is a base card component that's been used in ProfileCompletionBaseCard
// TODO: refactor NotificationItemCard and relationship card to use this component
function BaseItemCard({
  leftComponent,
  infoComponent,
  rightComponent,
  additionalStyle,
}: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: Spacings.s2,
    },
    infoContainer: {
      flex: 1,
      marginLeft: Spacings.s3,
    },
  });

  return (
    <View style={[styles.container, additionalStyle]}>
      <View>{leftComponent}</View>
      <View style={styles.infoContainer}>{infoComponent}</View>
      <View>{rightComponent}</View>
    </View>
  );
}

export default BaseItemCard;
